module.exports = __webpack_public_path__ + "static/media/GitHub-Mark-Light-32px.7e86b188.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/GitHub-Mark-Light-32px.png
 ** module id = 179
 ** module chunks = 0
 **/